import {
  Qualification,
  RangeQualificationDatum,
  SelectableQualificationDatum,
} from '../models';

export const getQualificationName = (qualification: Qualification): string => {
  return qualification.qualificationName;
};

export const getQualificationOptions = (
  qualification: Qualification,
): SelectableQualificationDatum[] => {
  return (qualification.data as SelectableQualificationDatum[]) || [];
};

export const hasCensusData = (qualification: Qualification): boolean => {
  return qualification.census.enabled && !!qualification.census.data?.length;
};

export const getQualificationRange = (
  qualification: Qualification,
): RangeQualificationDatum => {
  return (qualification.data as RangeQualificationDatum[])[0];
};
